import * as React from 'react';
import { connect } from 'react-redux';
import UtilityService from '../../services/UtilityService';
import * as AuthorizationStore from '../../store/Authorization';

class DownloadPartnerLogFile extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            message: "",
            tempFileNamePath: "",
            tempFileName: "",
            gettingFile: false
        };

        this.downloadPartnerLog = this.downloadPartnerLog.bind(this);
    }

    private emptyState() {
        return {
            message: ""
        };
    }

    downloadPartnerLog = async () => {
        const partner = AuthorizationStore.getImpactPartnerFromLocalStorage();
        if (partner) {
            this.setState({ gettingFile: true }, () => {
            });

            const data = await UtilityService.downloadPartnerLog(partner.Id);
            if (data) {
                var tempFileName = data.value;
                var fileParts = tempFileName.split('/');
                this.setState({ tempFileNamePath: data.value, tempFileName: fileParts[fileParts.length - 1], gettingFile: false });
            }
        }
    }

    public render() {
        const { message, tempFileName, tempFileNamePath, gettingFile } = this.state;
        return (
            <React.Fragment>
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12 mt-2">
                            <button className="btn primary" onClick={this.downloadPartnerLog}>Get Latest Log File</button>
                            &nbsp; {!gettingFile && tempFileNamePath && tempFileNamePath !== "" &&
                                <a href={tempFileNamePath}>{tempFileName}</a>
                            }
                            {gettingFile &&
                                <>Loading...</>
                            }
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
};

export default connect()(DownloadPartnerLogFile);
